import { Defaults } from "./defaults";
const { getButton } = require("../../config.json");
$(() => {
    Defaults.init();
    const MOBILE_MENU_BREAKPOINT = 1300;
    const getMenuElements = ($toggle) => {
        const $mainMenu = $toggle.closest('.main-menu');
        const $menu = $mainMenu.find('.rs-menu').first();
        const $nav = $menu.find('ul.nav-menu').first();
        return { $menu, $nav };
    };
    const setMenuClosed = ($toggle, $menu) => {
        $toggle.removeClass('rs-menu-toggle-open').addClass('rs-menu-toggle-close');
        $menu.stop(true, true).addClass('rs-menu-close').css('height', '0px');
    };
    const syncMenuState = () => {
        if (window.innerWidth <= MOBILE_MENU_BREAKPOINT) {
            $('a.rs-menu-toggle').each((_, element) => {
                const $toggle = $(element);
                const { $menu } = getMenuElements($toggle);
                if (!$menu.length) {
                    return;
                }
                if (!$toggle.hasClass('rs-menu-toggle-open')) {
                    setMenuClosed($toggle, $menu);
                }
            });
            return;
        }
        $('a.rs-menu-toggle').removeClass('rs-menu-toggle-open').addClass('rs-menu-toggle-close');
        $('.main-menu .rs-menu').removeClass('rs-menu-close').css('height', '');
    };
    const bindMobileToggle = () => {
        $('a.rs-menu-toggle').off('click').on('click', function (e) {
            e.preventDefault();
            const $toggle = $(this);
            const { $menu, $nav } = getMenuElements($toggle);
            if (!$menu.length || !$nav.length) {
                return;
            }
            const menuHeight = $nav.outerHeight(true) || 0;
            if ($toggle.hasClass('rs-menu-toggle-open')) {
                setMenuClosed($toggle, $menu);
                return;
            }
            $toggle.removeClass('rs-menu-toggle-close').addClass('rs-menu-toggle-open');
            $menu.stop(true, true)
                .removeClass('rs-menu-close')
                .animate({ height: menuHeight }, { queue: false, duration: 300 });
        });
    };
    bindMobileToggle();
    syncMenuState();
    let resizeTimer;
    $(window).on('load resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
            bindMobileToggle();
            syncMenuState();
        }, 150);
    });
    $(document).on('click', ".parent-module", (e) => {
        const $this = $(e.currentTarget);
        const $subMenu = $this.siblings('.sub-menu');
        $subMenu.toggleClass('visible');
        // Recalcular altura del menú cuando se abre/cierra un sub-menú
        // para que el contenido no quede clipeado por overflow:hidden
        const $menu = $this.closest('.rs-menu');
        const $nav = $menu.find('ul.nav-menu').first();
        const $toggle = $menu.closest('.main-menu').find('.rs-menu-toggle').first();
        if ($menu.length && $nav.length && $toggle.hasClass('rs-menu-toggle-open')) {
            const newHeight = $nav.outerHeight(true) || 0;
            $menu.stop(true, true).css('height', newHeight);
        }
    });
});
(function () {
    const options = getButton;
    const proto = document.location.protocol, host = "getbutton.io", url = proto + "//static." + host;
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = url + '/widget-send-button/js/init.js';
    s.onload = function () {
        WhWidgetSendButton.init(host, proto, options);
    };
    const x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
})();
import "expose-loader?exposes[]=JSZip!jszip";
import "expose-loader?exposes[]=App!./modules/app";
